export default __webpack_public_path__ + "static/geomanist-medium-webfont-2e0c587db0a8fb37cb8179a0bce1258b.woff2";